import { ActionRequestStatus, ActionRequestType } from '@billing/validation';
import { ActionRequest, User } from 'interfaces';
import { ActionCard } from './ActionCard';

export const RequestCard = ({
  request,
  statusColor,
  typeColor,
  typeLabel,
  testId,
}: {
  request: ActionRequest;
  statusColor: Record<ActionRequestStatus, string>;
  typeColor: Record<ActionRequestType, string>;
  typeLabel: string;
  testId?: string;
}) => {
  return (
    <ActionCard
      title="Clerk"
      reviewer={request.requestedByUser as Partial<User>}
      date={request.createdAt.toString()}
      message={request.message}
      status={request.status}
      type={request.type}
      typeLabel={typeLabel}
      statusColor={statusColor}
      typeColor={typeColor}
      testID={testId}
    />
  );
};
